import { CampaignDonorsState } from "./campaignDonors.types";

export const initialState: CampaignDonorsState = {
  data: [],
  loading: false,
  error: null,
};
